import { Box, Typography } from '@mui/material';
import { Stack } from '@mui/system';

import UploadIcon from '../../../../assets/svg/upload.svg';

interface CompanyLogoUploadProps {
  value: File | null;
  setValue: (value: File | null) => void;
}

const CompanyLogoUpload = ({ value, setValue }: CompanyLogoUploadProps) => {
  
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target && event.target.files) {
      const file = event.target.files[0];
      if (file && file.type === 'image/png' || file.type === 'image/jpeg') {
        setValue(file);
      }
    }
  };

  return (
    <Stack>
      <Typography
        sx={{
          fontFamily: 'Schibsted Grotesk, sans-serif',
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: '125%',
          color: '#181818',
          marginBottom: '12px',
        }}
      >
          Company Logo
      </Typography>
      <Stack direction='row' gap={1} alignItems='center'>
        {value !== null && <Box component='img' src={ URL.createObjectURL(value)} sx={{ width: '80px', height: '80px' }}/>}
        <Box 
          component='label' 
          htmlFor="logo-upload"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            border: '1px solid #D1D1D1',
            borderRadius: '6px',
            padding: '20px 24px',
            width: '200px',
            cursor: 'pointer',
          }}
        >
          <Box component='img' src={UploadIcon}/>
          <Typography sx={{
            fontFamily: 'Schibsted Grotesk, sans-serif',
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '125%',
            color: '#181818',
            padding: '12px 16px',
          }}>Choose File</Typography>
          <input
            type="file"
            id="logo-upload"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default CompanyLogoUpload;
